module.exports = __webpack_public_path__ + "img/资讯详情.62929ff5.png";